define('i18n/zh-cn',['require','ns'],function (require) {
	'use strict';

	var ns = require('ns');

	ns.resources = ns.resources || {};

	ns.resources['zh-cn'] = {
		resendVerificationEmailSuccess: '成功',
        fieldIsRequired: '这里必须填入资料',
        passwordMismatch: '这些密码不相符',
        passwordInvalid: '密码最少包含8位英文数字组合',
        live: '直播',
        livePending: '即将直播',
        skymateBadge: '月费会员',
        skyplusBadge: '付费点播',
        freeForMemberBadge: '登入观看'
	};
});
